// extracted by mini-css-extract-plugin
export default {"banner":"M9japv","appIcon":"l8HiZU","cta":"I4pIla","description":"zHvcnZ"};